import { Box, Flex, Grid, GridItem, Image, Input, Text, Drawer, DrawerOverlay, DrawerContent, DrawerCloseButton, DrawerHeader, DrawerBody, FormControl, FormLabel, Button, Center, Spinner, FormErrorMessage } from "@chakra-ui/react";
import MyDiv from "./ivrCalling.style";
import { CustomButton, CustomToast, ActionEditIcon, CustomTable } from "../../../../components";
import { useEffect, useState } from "react";
import PlusIcon from "../../../../assets/images/Vector.svg";
import { useFetch } from "../../../../hooks/useFetch";
import { IIVRCalling, IVRCallingSchema } from "./model";
import { Column } from "../../../../components/CustomTable/customTable";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { HrlenseInput } from "../../../../components/Input/Input";

const IVRCalling = () => {
    const [records, setRecords] = useState<IIVRCalling[]>([]);
    const [drawerOpen, setDrawerOpen] = useState(false);
    const [isEditMode, setIsEditMode] = useState(false);
    const { addToast } = CustomToast();
    const { fetchApi, loading } = useFetch(addToast);

    const { control, handleSubmit, reset, formState: { errors } } = useForm<IIVRCalling>({
        resolver: yupResolver(IVRCallingSchema) as any,
        defaultValues: { id: 0, hr_No: "", accountant_No: "" }
    });

    useEffect(() => {
        loadRecords();
    }, []);

    const loadRecords = async () => {
        const response = await fetchApi<any[]>("IVR/IVR_Mast", "GET");
        if (response) {
            setRecords(response);
        }
    };

    const handleAddNew = () => {
        setIsEditMode(false);
        reset({ id: 0, hr_No: "", accountant_No: "" });
        setDrawerOpen(true);
    };

    const handleEdit = (record: IIVRCalling) => {
        setIsEditMode(true);
        reset(record);
        setDrawerOpen(true);
    };

    const onSubmit = async (data: IIVRCalling) => {

        if (isEditMode) {
            const response = await fetchApi(`IVR/IVR_Mast/${data.id}`, "PUT", data, null, "Record updated successfully");
            if (response) {
                loadRecords();
                setDrawerOpen(false);
            }
        } else {
            const response = await fetchApi<any>("IVR/IVR_Mast", "POST", data, null, "Record added successfully");
            if (response) {
                loadRecords();
                setDrawerOpen(false);
            }
        }
    };

    return (
        <MyDiv>
            <Box position="relative" minH="300px">
                {loading ? (
                    <Center position="absolute" top={0} left={0} right={0} bottom={0}>
                        <Spinner thickness="4px" speed="0.65s" emptyColor="gray.200" color="#006838" size="xl" />
                    </Center>
                ) : (
                    <>
                        <Flex className="page_heading flex_header">
                            <Text className="font-poppins text_semibold text_3xl">IVR Master List</Text>
                            <Flex gap={2}>
                                <CustomButton title="Add New Setting" className=" btn font-poppins text_sm text_medium" rightIcon={<Image src={PlusIcon} className="logo" />} onClick={handleAddNew} />
                            </Flex>
                        </Flex>
                        <Grid className="grid_container">
                            <GridItem colSpan={12}>
                                <CustomTable value={records} emptyMessage="No Records Found">
                                    <Column<any> header="S. No" body={(_, index) => index + 1} />
                                    <Column<any> header="HR No" body={(rec) => rec.hr_No} />
                                    <Column<any> header="Accountant No" body={(rec) => rec.accountant_No} />
                                    <Column<any> header="Action" body={(rec) => (<ActionEditIcon onClick={() => handleEdit(rec)} />)} />
                                </CustomTable>
                            </GridItem>
                        </Grid>
                        <Drawer isOpen={drawerOpen} placement="right" onClose={() => setDrawerOpen(false)} size="sm">
                            <DrawerOverlay />
                            <DrawerContent>
                                <form onSubmit={handleSubmit(onSubmit)}>
                                    <DrawerCloseButton />
                                    <DrawerHeader borderBottomWidth="1px">
                                        {isEditMode ? "Edit IVR Setting" : "Add New IVR Setting"}
                                    </DrawerHeader>
                                    <DrawerBody display="flex" flexDirection="column" justifyContent="space-between" height="100%">
                                        <Box py={4}>
                                            <HrlenseInput name="hr_No" control={control} errors={errors} label="HR No" type="text" placeholder="Enter HR Number" isRequired />
                                            <Box mb={4} />
                                            <HrlenseInput name="accountant_No" control={control} errors={errors} label="Accountant No" type="text" placeholder="Enter Accountant Number" isRequired />
                                        </Box>
                                        <Flex justify="flex-end" mt={4} gap={2} mb={4}>
                                            <Button className="font-poppins text_sm text_medium" onClick={() => setDrawerOpen(false)} style={{ backgroundColor: "#D92F34", color: "white" }}> Cancel </Button>
                                            <Button type="submit" isLoading={loading} className="font-poppins text_sm text_medium" style={{ backgroundColor: "#006838", color: "white" }} > {isEditMode ? "Update Setting" : "Add Setting"} </Button>
                                        </Flex>
                                    </DrawerBody>
                                </form>
                            </DrawerContent>
                        </Drawer>
                    </>
                )}
            </Box>
        </MyDiv>
    );
};

export default IVRCalling;